import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { getConfirmDeleteDialog } from "../Components/confirmDeleteDialog";
import { ThemeProvider } from "@mui/material/styles";
import Table_theme from "../Themes/TableTheme";
import FormThemes from "../Themes/FormThemes";
import MainLayout from "../Themes/MainLayout";
import { validatePhone } from "../utils/phoneValidator";
import {
  TextField,
  FormHelperText,
  OutlinedInput,
  Grid,
  MenuItem,
  Tooltip,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import {
  Pagination,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  CssBaseline,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  InputProps,
  TableContainer,
  TableHead,
  TableRow,
  Popover,
  InputAdornment,
  Switch,
  Alert,
  Typography,
} from "@mui/material";
import { ReactComponent as DeleteIcon } from "../Icons/Delete.svg";
import { ReactComponent as SettingsIcon } from "../Icons/Settings.svg";
import CloseIcon from "@mui/icons-material/Close";
import { Add, Flag, FilterList, Search } from "@mui/icons-material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useCurrentUser } from "../utils/useCurrentUser";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const OrganiFields = [
  "bo_id",
  "bo_name",
  "bo_type",
  "address",
  "email_id",
  "fax",
  "website",
  "phone_no_1",
  "phone_no_2",
  "country",
  "location",
];

const Organization = () => {
  const { empId, boId, hasPermission } = useCurrentUser();
  const [fieldErrors, setFieldErrors] = useState({});
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [Organi, setOrgani] = useState([]);
  const [filters, setFilters] = useState({});
  const [anchorEls, setAnchorEls] = useState({});
  const [orgTypes, setOrgTypes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [countryCodes, setCountryCodes] = useState([]);

  const [columnVisibility, setColumnVisibility] = useState(() => {
    const initial = {};
    OrganiFields.forEach((f) => (initial[f] = true));
    return initial;
  });
  const [columnAnchorEl, setColumnAnchorEl] = useState(null);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [statusFlags, setStatusFlags] = useState([]);
  const [statusFilter, setStatusFilter] = useState("ACTIVE");
  const [isEditing, setIsEditing] = useState(false); // Added isEditing state
  const [newOrganization, setNewOrganization] = useState({
    delete_flag: "N",
    data_source: "UI",
  });
  const [EditOrganization, setEditOrganization] = useState({});
  const [originalEditData, setOriginalEditData] = useState({});
  const [search, setSearch] = useState("");

  const rowsPerPage = 10;
  const confirmDelete = (org) => {
    if (!org || !org.bo_id) {
      console.error("Invalid organization object for delete");
      return;
    }
    setSelectedOrganization(org);
    setDeleteDialogOpen(true);
  };
  const fieldLabels = {};
  OrganiFields.forEach((field) => {
    if (field === "bo_id") {
      fieldLabels[field] = "Organization ID";
    } else if (field === "bo_name") {
      fieldLabels[field] = "Organization Name";
    } else if (field === "bo_type") {
      fieldLabels[field] = "Organization Type";
    } else {
      fieldLabels[field] = field
        .replace(/_/g, " ")
        .replace(/\b\w/g, (l) => l.toUpperCase());
    }
  });

  useEffect(() => {
    const fetchCountryCodes = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/commonVariables/countryCodes`);
        setCountryCodes(res.data);
      } catch (err) {
        console.error("Error fetching country codes:", err);
      }
    };

    fetchCountryCodes();
  }, []);

  const fetchorganization = useCallback(async () => {
    try {
      const params = {
        page: page + 1,
        limit: rowsPerPage,
        ...filters,
        search: search.trim(),
      };
      if (statusFilter) {
        params.status = statusFilter;
      }

      const response = await axios.get(`${BASE_URL}/Organization/paginated`, {
        params,
      });
      setOrgani(response.data.data);
      setTotalCount(response.data.total);
    } catch (err) {
      console.error("Error fetching Organization Details:", err);
    }
  }, [page, filters, search, statusFilter]);

  useEffect(() => {
    fetchorganization();
  }, [fetchorganization]);
  useEffect(() => {
    if (alertMsg) {
      const timer = setTimeout(() => {
        setAlertMsg("");
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [alertMsg]);
  useEffect(() => {
    const fetchStatusFlags = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/commonVariables/statusFlag`);
        setStatusFlags(res.data);
      } catch (err) {
        console.error("Error fetching status flags:", err);
      }
    };

    fetchStatusFlags();
  }, []);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/commonVariables/countries`);
        setCountries(res.data);
      } catch (err) {
        console.error("Error fetching countries:", err);
      }
    };
    const fetchOrgTypes = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/commonVariables/orgtype/bo_type`
        );
        setOrgTypes(res.data);
      } catch (err) {
        console.error("Error fetching organization types:", err);
      }
    };
    fetchCountries();
    fetchOrgTypes();
  }, []);

  useEffect(() => {
    const current = isEditing ? EditOrganization : newOrganization;
    if (!current.country) return;

    const fetchCities = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/commonVariables/cities-by-country/${current.country}`
        );
        setCities(res.data);
      } catch (err) {
        console.error("Error fetching cities:", err);
      }
    };

    fetchCities();
  }, [isEditing ? EditOrganization.country : newOrganization.country]);

  const checkBoIdExists = async (bo_id) => {
    try {
      const res = await axios.get(`${BASE_URL}/Organization/exists/${encodeURIComponent(bo_id)}`);
      return res.data.exists;
    } catch (err) {
      console.error("Error checking BO ID:", err);
      return false; //safe fallback
    }
  };
  const validateOrganization = async (
    org,
    checkBoIdExists,
    originalBoId = null
  ) => {
    const errors = {};
    const mandatoryFields = ["bo_id", "bo_name", "bo_type"];

    // Check mandatory fields
    mandatoryFields.forEach((field) => {
      if (!org[field] || org[field].toString().trim() === "") {
        errors[field] = `${fieldLabels[field]} is required`;
      }
    });

    // BO ID format: only alphanumeric
    if (org.bo_id?.trim() && !/^[a-zA-Z0-9]+$/.test(org.bo_id.trim())) {
      errors.bo_id = "Organization ID can only contain letters and numbers";
    }

    // BO Name format: only alphanumeric and spaces, max 100 chars
    if (org.bo_name?.trim() && !/^[a-zA-Z0-9 ]+$/.test(org.bo_name.trim())) {
      errors.bo_name = "Organization Name can only contain letters, numbers and spaces";
    } else if (org.bo_name?.trim().length > 100) {
      errors.bo_name = "Organization Name cannot exceed 100 characters";
    }

    // Address max 255 chars
    if (org.address?.trim().length > 255) {
      errors.address = "Address cannot exceed 255 characters";
    }

    // Email validation
    const email = org.email_id?.trim();
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // const allowedDomains = [
      const forbiddenDomains = [
      "gmail.com",
      "yahoo.com",
    ];

    // if (!email) {
    //   // empty or spaces only — no error (not mandatory)
    // } else if (!emailRegex.test(email)) {
    //   errors.email_id = "Invalid email format";
    // } else {
    //   const domain = email.split("@")[1].toLowerCase();
    //   if (!allowedDomains.includes(domain)) {
    //     errors.email_id = "Please enter a valid email";
     if (email) {
      if (!emailRegex.test(email)) {
        errors.email_id = "Invalid email format";
      } else {
        const domain = email.split("@")[1].toLowerCase();
        if (forbiddenDomains.includes(domain)) {
          errors.email_id = "Personal email not allowed. Use corporate email.";
        }
      }
    }
    // Phone number - Check total digits (7–15 digits)
    const phone1Result = validatePhone(org.phone_no_1);
    if (!phone1Result.isValid) {
      errors.phone_no_1 = phone1Result.error;
    }

    const phone2Result = validatePhone(org.phone_no_2);
    if (!phone2Result.isValid) {
      errors.phone_no_2 = phone2Result.error;
    }

    // ===== FAX VALIDATION =====
    // Fax allows more digits (max 20)
    const faxRegex = /^\+(?:[\d\s-()]){6,25}\d$/;
    const countDigits = (str) => str.replace(/\D/g, "").length;
    if (org.fax?.trim()) {
      const digits = countDigits(org.fax);

      if (!faxRegex.test(org.fax.trim()) || digits < 6 || digits > 20) {
        errors.fax =
          "Invalid fax number. Include country code(e.g., +1 212-555-1234).";
      }
    }

    // BO ID uniqueness check (skip if unchanged)
    if (org.bo_id?.trim() && org.bo_id.trim() !== originalBoId) {
      const exists = await checkBoIdExists(org.bo_id.trim());
      if (exists) {
        errors.bo_id = "BO ID already exists";
      }
    }
    // Website validation (optional)
    const website = org.website?.trim();
    if (website) {
      const websiteRegex =
        /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/;
      if (!websiteRegex.test(website)) {
        errors.website = "Invalid website URL";
      }
    }
    return errors;
  };

  const handleAdd = async () => {
    const errors = await validateOrganization(newOrganization, checkBoIdExists);

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }
    try {
      await axios.post(`${BASE_URL}/Organization`, {
        ...newOrganization,
        created_by: empId,
      });
      setOpen(false);
      setNewOrganization({
        delete_flag: "N",
        data_source: "UI",
        bo_id: boId,
        created_by: empId,
        empId,
      });
      setAlertMsg("New Organization added successfully!");
      setAlertSeverity("success");
      fetchorganization();
      setFieldErrors({});
    } catch (err) {
      console.error("Add failed:", err.response?.data || err.message);
      setAlertMsg("Failed to add organization");
      setAlertSeverity("error");
    }
  };

  const handleEdit = async () => {
    try {
      // Pass the original BO ID to skip uniqueness check if unchanged
      const errors = await validateOrganization(
        EditOrganization,
        checkBoIdExists,
        EditOrganization.bo_id
      );

      if (Object.keys(errors).length > 0) {
        setFieldErrors(errors);
        return;
      }

      await axios.put(`${BASE_URL}/Organization/${EditOrganization.bo_id}`, {
        ...EditOrganization,
        modified_by: empId,
      });

      setEditOpen(false);
      setAlertMsg("Record updated successfully!");
      setAlertSeverity("success");
      fetchorganization();
      setFieldErrors({});
    } catch (err) {
      console.error("Update failed:", err.response?.data || err.message);
      setAlertMsg("Failed to update organization");
      setAlertSeverity("error");
    }
  };

  const handleFilterIconClick = (field, event) => {
    setAnchorEls((prev) => ({ ...prev, [field]: event.currentTarget }));
  };

  const handleFilterClose = (field) => {
    setAnchorEls((prev) => ({ ...prev, [field]: null }));
  };

  const handleDelete = async (bo_id) => {
    try {
      await axios.patch(`${BASE_URL}/Organization/${bo_id}`, {
        modified_by: empId,
      });
      setAlertMsg("Record deleted successfully..");
      setAlertSeverity("success");
      fetchorganization();
    } catch (err) {
      console.error("Delete failed:", err.response?.data || err.message);
      setAlertMsg("Failed to delete Organization");
      setAlertSeverity("error");
    }
  };

  const handleToggleFlag = async (bo_id, currentFlag) => {
    const newFlag = currentFlag === "Y" ? "N" : "Y";

    try {
      await axios.put(`${BASE_URL}/Organization/${bo_id}/toggle-flag`, {
        bo_id,
        delete_flag: newFlag,
        modified_by: empId,
      });

      setOrgani((prev) =>
        prev.map((org) =>
          org.bo_id === bo_id ? { ...org, delete_flag: newFlag } : org
        )
      );
      setAlertMsg("Toggle flag updated successfully..");
      setAlertSeverity("success");
      fetchorganization();
    } catch (error) {
      console.error("Error updating flag:", error);
      setAlertMsg("Failed to update flag");
      setAlertSeverity("error");
    }
  };

  const commonSx = {
    "& .MuiInputBase-root": {
      fontSize: "14px",
      minHeight: 30,
      borderRadius: "9px",
      backgroundColor: "#fafafa",
      color: "#292727ff",
    },
    "& .MuiInputBase-input": {
      fontSize: "12px",
      padding: "8.5px 14px",
    },
    "& .MuiInputLabel-root": {
      fontSize: "14px",
    },
    "& .MuiSelect-select": {
      fontSize: "12px",
      padding: "8.5px 14px",
    },

    mt: 0.8,
    mb: 0,
    width: "240px",
  };

  const renderField = (field, state, setState, isEditMode = false) => {
    const mandatoryFields = ["bo_id", "bo_name", "bo_type"];
    const handleChange = (e) => {
      const { name, value } = e.target;
      // bo_id: allow only alphanumeric, hyphen, underscore
      if (name === "bo_id") {
        const sanitized = value.replace(/[^a-zA-Z0-9]/g, "");
        setState((prev) => ({ ...prev, [name]: sanitized }));
        setFieldErrors((prev) => ({ ...prev, [name]: "" }));
        return;
      }
      // bo_name: allow only alphanumeric and spaces
      if (name === "bo_name") {
        const sanitized = value.replace(/[^a-zA-Z0-9 ]/g, "").slice(0, 100);
        setState((prev) => ({ ...prev, [name]: sanitized }));
        setFieldErrors((prev) => ({ ...prev, [name]: "" }));
        return;
      }
      // email: trim spaces
      if (name === "email_id") {
        setState((prev) => ({ ...prev, [name]: value.trim() }));
        setFieldErrors((prev) => ({ ...prev, [name]: "" }));
        return;
      }
      setState((prev) => ({ ...prev, [name]: value }));
      setFieldErrors((prev) => ({ ...prev, [name]: "" }));
    };

    const isRequired = mandatoryFields.includes(field);
    const isDisabled = isEditMode && field === "bo_id";

    const label = `${fieldLabels[field] || field}${isRequired ? " " : ""}`;

    if (field === "address") {
      return (
        <TextField
          key={field}
          label={`${label} (${(state[field] || "").length}/255)`}
          name={field}
          value={state[field] || ""}
          onChange={handleChange}
          fullWidth
          size="small"
          margin="dense"
          multiline
          required={isRequired}
          error={!!fieldErrors[field]}
          helperText={fieldErrors[field]}
          InputLabelProps={{ shrink: true }}
          inputProps={{ maxLength: 255 }}
          minRows={2}
          maxRows={2}
          sx={{
            width: "240px",
            // 1) Make the textarea start at the top
            "& .MuiInputBase-root": {
              alignItems: "flex-start",
              padding: 0.5, // remove default padding
              whiteSpace: "normal",
            },

            // 2) Control text padding (this makes text start under label letter)
            "& .MuiInputBase-input": {
              padding: "8px", // same as your working page
              overflow: "auto",
            },

            // 3) Adjust label position (critical!)
            "& .MuiInputLabel-root": {
              transform: "translate(16px, -9px) scale(0.75)",
              transformOrigin: "top left",
            },
          }}
        />
      );
    }

    if (field === "bo_type") {
      return (
        <FormControl
          key={field}
          name={field}
          onChange={handleChange}
          fullWidth
          size="small"
          margin="dense"
          required={isRequired}
          error={!!fieldErrors[field]}
          InputLabelProps={{ shrink: true }}
          sx={commonSx}
        >
          <InputLabel id="bo-type-label" shrink>
            {label}
          </InputLabel>
          <Select
            labelId="bo-type-label"
            name="bo_type"
            value={state[field] || ""}
            onChange={(e) => {
              const { name, value } = e.target;
              setState((prev) => ({ ...prev, [name]: value }));
              setFieldErrors((prev) => ({ ...prev, [name]: "" }));
            }}
            input={<OutlinedInput notched label={label} />}
          >
            {orgTypes.map((t) => (
              <MenuItem key={t.code} value={t.code} sx={{ fontSize: "12px" }}>
                {t.organization_type || t.Organization_type}
              </MenuItem>
            ))}
          </Select>

          {fieldErrors[field] && (
            <FormHelperText>{fieldErrors[field]}</FormHelperText>
          )}
        </FormControl>
      );
    }

    if (field === "country") {
      return (
        <FormControl
          key={field}
          fullWidth
          size="small"
          margin="dense"
          required={isRequired}
          name={field}
          sx={commonSx}
        >
          <InputLabel id="country-label" shrink>
            {label}
          </InputLabel>
          <Select
            labelId="country-label"
            name="country"
            value={state[field] || ""}
            onChange={(e) => {
              const { name, value } = e.target;
              setState((prev) => ({ ...prev, [name]: value, location: "" }));
              setFieldErrors((prev) => ({ ...prev, [name]: "" }));
            }}
            input={<OutlinedInput notched label={label} />}
          >
            {countries.map((c) => (
              <MenuItem
                key={c.country_id}
                value={c.country_id}
                sx={{ fontSize: "12px" }}
              >
                {c.country_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    }
    if (field === "location") {
      return (
        <FormControl
          fullWidth
          size="small"
          margin="dense"
          required={isRequired}
          sx={commonSx}
          disabled={!state.country} // disable until country selected
        >
          <InputLabel shrink>City</InputLabel>
          <Select
            name="location"
            value={state.location}
            onChange={(event) => {
              const { name, value } = event.target;
              setState((prev) => ({ ...prev, [name]: value }));
            }}
            input={<OutlinedInput notched label="City" />} // label matches InputLabel
          >
            {cities && cities.length > 0 ? (
              cities.map((city) => (
                <MenuItem
                  key={city.city_id}
                  value={city.city_name} // <-- store city name here
                  sx={{ fontSize: 12 }}
                >
                  {city.city_name}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No cities available</MenuItem>
            )}
          </Select>
        </FormControl>
      );
    }
    if (field === "phone_no_1" || field === "phone_no_2") {
      const labelText = field === "phone_no_1" ? "Phone No 1" : "Phone No 2";
      const phoneValue = state[field] || "";

      const extractedCode =
        phoneValue.startsWith("+") && phoneValue.includes(" ")
          ? phoneValue.split(" ")[0]
          : countryCodes?.[0]?.label || "+91";

      const extractedPhone =
        phoneValue.startsWith("+") && phoneValue.includes(" ")
          ? phoneValue.split(" ").slice(1).join("")
          : "";

      return (
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1,
            width: "100%",
          }}
        >
          {/* Code dropdown (same height as textfield) */}
          <FormControl
            size="small"
            sx={{
              width: "70px",
              mt: "6px",
              "& .MuiInputBase-root": {
                ...commonSx["& .MuiInputBase-root"], // match textfield height
                minHeight: "30px",
              },
            }}
          >
            <InputLabel shrink>Code</InputLabel>
            <Select
              value={extractedCode}
              label="Code"
              onChange={(e) => {
                const newValue = `${e.target.value} ${extractedPhone}`;
                setState((prev) => ({ ...prev, [field]: newValue }));
                setFieldErrors((prev) => ({ ...prev, [field]: "" }));
              }}
              input={<OutlinedInput notched label="Code" />}
            >
              {countryCodes?.map((c) => (
                <MenuItem key={c.code} value={c.label} sx={{ fontSize: 12 }}>
                  {c.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Phone textfield perfectly aligned */}
          <TextField
            size="small"
            fullWidth
            label={labelText}
            value={extractedPhone}
            onChange={(e) => {
              const newValue = `${extractedCode} ${e.target.value.trim()}`;
              setState((prev) => ({ ...prev, [field]: newValue }));
              setFieldErrors((prev) => ({ ...prev, [field]: "" }));
            }}
            error={!!fieldErrors[field]}
            helperText={fieldErrors[field]}
            InputLabelProps={{ shrink: true }}
            sx={{
              ...commonSx,
              width: "163px",
              //height: "40px",

              "& .MuiFormHelperText-root": {
                whiteSpace: "normal", // allow wrapping
                marginLeft: 0,
                lineHeight: 1.4,
              },
              //  Increase actual input text font size
              "& .MuiInputBase-input": {
                fontSize: "14px", // <-- Increase this value (13, 14, 15, 16)
                padding: "8px 12px",
              },

              //  Optional: increase label size
              "& .MuiInputLabel-root": {
                fontSize: "14px",
              },
            }} // ← THIS FIXES HEIGHT & ALIGNMENT
          />
        </Box>
      );
    }

    return (
      <TextField
        key={field}
        label={
          field === "bo_name"
            ? `${label} (${(state[field] || "").length}/100)`
            : label
        }
        name={field}
        value={state[field] || ""}
        onChange={handleChange}
        fullWidth
        size="small"
        margin="dense"
        required={isRequired}
        error={!!fieldErrors[field]}
        helperText={fieldErrors[field]}
        InputLabelProps={{ shrink: true }}
        disabled={isDisabled}
        sx={commonSx}
      />
    );
  };

  return (
    <MainLayout>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        gap={1.5}
        mb={2}
      >
        <IconButton onClick={(e) => setColumnAnchorEl(e.currentTarget)}>
          <SettingsIcon />
        </IconButton>
        <Popover
          open={Boolean(columnAnchorEl)}
          anchorEl={columnAnchorEl}
          onClose={() => setColumnAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              mt: 1,
              p: 1,
              width: 220,
              maxHeight: 300,
              overflowY: "auto",
              borderRadius: 2,
            },
          }}
        >
          {OrganiFields.map((field) => (
            <MenuItem key={field} disableGutters sx={{ p: 0, mb: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  border: "1px solid #ccc",
                  borderRadius: 1.5,
                  px: 2,
                  py: 1,
                  backgroundColor: "#fff",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "0.8rem",
                    color: "#333",
                    fontWeight: "bold",
                  }}
                >
                  {fieldLabels[field]}
                </Typography>
                <Switch
                  size="small"
                  checked={columnVisibility[field]}
                  onChange={() =>
                    setColumnVisibility((prev) => ({
                      ...prev,
                      [field]: !prev[field],
                    }))
                  }
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#2DB0E4",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#2DB0E4",
                    },
                  }}
                />
              </Box>
            </MenuItem>
          ))}
        </Popover>

        {hasPermission("Organization", "Edit") && (
          <Button
            variant="contained"
            size="small"
            onClick={() => {
              setOpen(true);
              setIsEditing(false);
              setNewOrganization({
                delete_flag: "N",
                data_source: "UI",
                created_by: empId,
              });
            }}
            sx={{
              fontWeight: "bold",
              borderRadius: "8px",
              px: 2.5,
              height: 36,
              backgroundColor: "#2DB0E4",
            }}
            startIcon={<Add />}
          >
            Add
          </Button>
        )}
        <TextField
          size="small"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            width: 250,
            "& input": { fontSize: 14 }, // input + placeholder
            "& input::placeholder": { fontSize: 12 }, // placeholder only
          }}
          InputProps={{
            sx: {
              height: 36, // Reduce overall input height
              paddingRight: 0,
            },
            startAdornment: (
              <InputAdornment position="start">
                <Search fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          select
          label="Status"
          value={statusFilter || "All"}
          onChange={(e) => setStatusFilter(e.target.value)}
          size="small"
          sx={{
            width: 200,
            // Make height match the 36px of the search field
            "& .MuiInputBase-root": {
              height: 36,
            },

            // Fix vertical alignment of text
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              fontSize: 12,
              padding: "0 14px",
            },

            // Label font size
            "& .MuiInputLabel-root": { fontSize: "14px" },
          }}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                sx: {
                  "& .MuiMenuItem-root": {
                    fontSize: "14px",
                    minHeight: "32px",
                  },
                },
              },
            },
          }}
        >
          <MenuItem value="All">All</MenuItem>
          {statusFlags.map((flag) => (
            <MenuItem key={flag.code} value={flag.code}>
              {flag.label}
            </MenuItem>
          ))}
        </TextField>
      </Box>
      <Box sx={{ width: "100%", overflowX: "auto", px: 0, py: 2, mt: "-10px" }}>
        {alertMsg && (
          <Box mb={2}>
            <Alert
              onClose={() => setAlertMsg("")}
              variant="standard"
              sx={{
                color: alertSeverity === "success" ? "#2E9F50" : "#FF0C0C",
                fontWeight: 500,
                backgroundColor: "#fff",
              }}
            >
              {alertMsg}
            </Alert>
          </Box>
        )}

        <ThemeProvider theme={Table_theme}>
          <CssBaseline />
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      whiteSpace: "nowrap",
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    Actions
                  </TableCell>
                  {OrganiFields.filter((f) => columnVisibility[f]).map(
                    (field) => (
                      <TableCell key={field}>
                        {fieldLabels[field]}
                        <IconButton
                          size="small"
                          onClick={(e) => handleFilterIconClick(field, e)}
                        >
                          <FilterList fontSize="small" />
                        </IconButton>
                        <Popover
                          open={Boolean(anchorEls[field])}
                          anchorEl={anchorEls[field]}
                          onClose={() => handleFilterClose(field)}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                          }}
                        >
                          <Box
                            p={2}
                            display="flex"
                            flexDirection="column"
                            gap={1}
                            width={200}
                          >
                            <TextField
                              size="small"
                              fullWidth
                              placeholder={`Filter ${fieldLabels[field]}`}
                              value={filters[field] || ""}
                              onChange={(e) =>
                                setFilters((prev) => ({
                                  ...prev,
                                  [field]: e.target.value,
                                }))
                              }
                            />
                            <Box display="flex" justifyContent="space-between">
                              <Button
                                variant="contained"
                                size="small"
                                onClick={() => handleFilterClose(field)}
                                sx={{ minWidth: 70 }}
                              >
                                Apply
                              </Button>
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={() => {
                                  setFilters((prev) => ({
                                    ...prev,
                                    [field]: "",
                                  }));
                                  handleFilterClose(field);
                                }}
                                sx={{ minWidth: 70 }}
                              >
                                Clear
                              </Button>
                            </Box>
                          </Box>
                        </Popover>
                      </TableCell>
                    )
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {Organi.length > 0 ? (
                  Organi.map((row, i) => (
                    <TableRow key={i}>
                      <TableCell>
                        <Box display="flex" gap={0.5} justifyContent="center">
                          <Tooltip
                            title={
                              hasPermission("Organization", "Edit")
                                ? "Edit"
                                : "No permission"
                            }
                          >
                            <span>
                              <IconButton
                                 onClick={() => {
                                  if (hasPermission("Organization", "Edit")) {
                                    setEditOrganization(row);
                                    setOriginalEditData(row);
                                    setEditOpen(true);
                                    setIsEditing(true);
                                  }
                                }}
                                disabled={
                                  !hasPermission("Organization", "Edit")
                                }
                                sx={{
                                  color: hasPermission("Organization", "Edit")
                                    ? "#2DB0E4"
                                    : "#ccc",
                                }}
                              >
                                <EditOutlinedIcon sx={{ fontSize: "16px" }} />
                              </IconButton>
                            </span>
                          </Tooltip>

                          <Tooltip
                            title={
                              hasPermission("Organization", "Delete")
                                ? "Delete"
                                : "No permission"
                            }
                          >
                            <span>
                              <IconButton
                                onClick={() =>
                                  hasPermission("Organization", "Delete") &&
                                  confirmDelete(row)
                                }
                                disabled={
                                  !hasPermission("Organization", "Delete")
                                }
                                sx={{
                                  color: hasPermission("Organization", "Delete")
                                    ? "#fc0404ff"
                                    : "#ccc",
                                }}
                              >
                                <DeleteIcon
                               
                                />
                              </IconButton>
                            </span>
                          </Tooltip>

                          <Tooltip
                            title={
                              hasPermission("Organization", "Edit")
                                ? "Toggle Delete Flag"
                                : "No permission"
                            }
                          >
                            <span>
                            <IconButton
                              size="small"
                              onClick={() =>
                                hasPermission("Organization", "Edit") &&
                                handleToggleFlag(row.bo_id, row.delete_flag)
                              }
                              disabled={!hasPermission("Organization", "Edit")}
                            >
                              <Flag
                                sx={{
                                  color:
                                    row.delete_flag === "N"
                                      ? "#2E9F50"
                                      : "#FF0C0C",
                                  width: 17,
                                  height: 17,
                                }}
                              />
                              </IconButton>
                              </span>
                          </Tooltip>
                        </Box>
                      </TableCell>

                      {OrganiFields.filter((f) => columnVisibility[f]).map(
                        (field) => (
                          <TableCell key={field} align="left">
                            {field === "country"
                              ? countries.find(
                                  (c) =>
                                    String(c.country_id) === String(row.country)
                                )?.country_name || row.country
                              : row[field]}
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={
                        OrganiFields.filter((f) => columnVisibility[f]).length +
                        1
                      }
                      align="center"
                    >
                      No matching data found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Box display="flex" justifyContent="center" mt={2}>
            <Pagination
              count={Math.ceil(totalCount / rowsPerPage)}
              page={page + 1}
              onChange={(_, newPage) => setPage(newPage - 1)}
              color="primary"
              variant="outlined"
              shape="rounded"
              sx={{
                "& .MuiPaginationItem-root": {
                  borderRadius: "8px",
                  minWidth: "32px",
                  height: "32px",
                  fontSize: "14px",
                },
                "& .Mui-selected": {
                  backgroundColor: "#b3dbea !important",
                  color: "black",
                  fontWeight: "bold",
                },
                "& .MuiPaginationItem-ellipsis": {
                  display: "none",
                },
              }}
            />
          </Box>
        </ThemeProvider>
      </Box>
      <ThemeProvider theme={FormThemes}>
        <CssBaseline />
        <Dialog
          open={open || editOpen}
          onClose={() => {
            setOpen(false);
            setEditOpen(false);
            setIsEditing(false);
            setFieldErrors({});
            setOriginalEditData({});
          }}
          fullWidth
          maxWidth="sm"
          sx={{
            "& .MuiDialog-paper": {
              borderRadius: 5,
              width: "540px",
              overflow: "visible",
              maxWidth: "95vw",
            },
          }}
        >
          <DialogTitle
            sx={{
              borderRadius: "12px",
              bgcolor: "#f5f5f5",
              p: 1,
              fontSize: "16px",
              fontWeight: 600,
              borderBottom: "1px solid #ddd",
            }}
          >
            {isEditing ? "Update Organization" : "Add Organization"}

            <IconButton
              aria-label="close"
              onClick={() => {
                setOpen(false);
                setEditOpen(false);
                setIsEditing(false);
                setFieldErrors({});
                setOriginalEditData({});
              }}
              sx={{ position: "absolute", right: 8, top: 5 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent
            sx={{
              width: "540px",
              pt: "18px",
              pr: "8px",
              pb: "18px",
              pl: "24px",
            }}
          >
            <Grid container spacing={1} mt={1.5}>
              {/* ROW 1 */}
              <Grid item xs={12} sm={6}>
                {renderField(
                  "bo_id",
                  isEditing ? EditOrganization : newOrganization,
                  isEditing ? setEditOrganization : setNewOrganization,
                  isEditing
                )}
              </Grid>

              <Grid item xs={12} sm={6}>
                {renderField(
                  "bo_name",
                  isEditing ? EditOrganization : newOrganization,
                  isEditing ? setEditOrganization : setNewOrganization,
                  isEditing
                )}
              </Grid>

              {/* ROW 2 */}
              <Grid item xs={12} sm={6}>
                {renderField(
                  "bo_type",
                  isEditing ? EditOrganization : newOrganization,
                  isEditing ? setEditOrganization : setNewOrganization,
                  isEditing
                )}
              </Grid>

              <Grid item xs={12} sm={6}>
                {renderField(
                  "email_id",
                  isEditing ? EditOrganization : newOrganization,
                  isEditing ? setEditOrganization : setNewOrganization,
                  isEditing
                )}
              </Grid>

              {/* ROW 3 — OPTION A: Phone No 1 & Phone No 2 (each one block) */}
              <Grid item xs={12} sm={6}>
                {renderField(
                  "phone_no_1",
                  isEditing ? EditOrganization : newOrganization,
                  isEditing ? setEditOrganization : setNewOrganization,
                  isEditing
                )}
              </Grid>

              <Grid item xs={12} sm={6}>
                {renderField(
                  "phone_no_2",
                  isEditing ? EditOrganization : newOrganization,
                  isEditing ? setEditOrganization : setNewOrganization,
                  isEditing
                )}
              </Grid>

              {/* ROW 4 */}
              <Grid item xs={12} sm={6}>
                {renderField(
                  "fax",
                  isEditing ? EditOrganization : newOrganization,
                  isEditing ? setEditOrganization : setNewOrganization,
                  isEditing
                )}
              </Grid>

              <Grid item xs={12} sm={6}>
                {renderField(
                  "website",
                  isEditing ? EditOrganization : newOrganization,
                  isEditing ? setEditOrganization : setNewOrganization,
                  isEditing
                )}
              </Grid>

              {/* ROW 5 */}
              <Grid item xs={12} sm={6}>
                {renderField(
                  "country",
                  isEditing ? EditOrganization : newOrganization,
                  isEditing ? setEditOrganization : setNewOrganization,
                  isEditing
                )}
              </Grid>

              <Grid item xs={12} sm={6}>
                {renderField(
                  "location",
                  isEditing ? EditOrganization : newOrganization,
                  isEditing ? setEditOrganization : setNewOrganization,
                  isEditing
                )}
              </Grid>

              {/* ROW 6 */}
              <Grid item xs={12}>
                {renderField(
                  "address",
                  isEditing ? EditOrganization : newOrganization,
                  isEditing ? setEditOrganization : setNewOrganization,
                  isEditing
                )}
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{ p: "8px 24px", justifyContent: "right" }}>
            <Button
              onClick={() => {
                setOpen(false);
                setEditOpen(false);
                setIsEditing(false);
                setFieldErrors({});
                setOriginalEditData({});
              }}
              variant="outlined"
              color="inherit"
              sx={{ mr: 1, color: "#555", borderColor: "#ccc" }}
            >
              Cancel
            </Button>

            <Button
                onClick={isEditing ? handleEdit : handleAdd}
                variant="contained"
                color="primary"
                disabled={isEditing && JSON.stringify(EditOrganization) === JSON.stringify(originalEditData)}
                sx={{
                  fontWeight: "bold",
                  borderRadius: "8px",
                  px: 2.5,
                  ...(isEditing
                    ? {
                        backgroundColor: "#4CAF50",
                        "&:hover": { backgroundColor: "#45A049" },
                      }
                    : {
                        backgroundColor: "#2DB0E4",
                        "&:hover": { backgroundColor: "#1D87B0" },
                      }),
                }}
              >
                {isEditing ? "Update" : "Save"}
              </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>

      {getConfirmDeleteDialog({
        open: deleteDialogOpen,
        onClose: () => {
          setDeleteDialogOpen(false);
          setSelectedOrganization(null);
        },
        onConfirm: () => {
          if (selectedOrganization) {
            handleDelete(selectedOrganization.bo_id);
          }
          setDeleteDialogOpen(false);
          setEditOrganization(null);
        },
        title: "Confirm Deletion",
        contentText: selectedOrganization
          ? `Are you sure you want to delete the organization of ${selectedOrganization.bo_name}?`
          : "Are you sure you want to delete this Organization?",
      })}
    </MainLayout>
  );
};

export default Organization;
